<template>
  <div class="sc-checkbox-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ScCheckbox'
}
</script>

<style lang="scss" scoped>
  label{
    cursor: pointer;
    font-size: 0.8em;
    color: $sc-checkbox-label-text-color;
    user-select: none;
  }

  .sc-checkbox-container {
    text-align: justify;
  }

  label:before {
    cursor: pointer;
    margin-right: 0.7em;
    content: "done";
    font-family: "Material Icons";
    font-size: $sc-checkbox-mark-size;
    font-weight: bold;
    text-align: center;
    display: inline-block;
    width: $sc-checkbox-width;
    height: $sc-checkbox-height;
    border: 1px solid #b0bec5;
    border-radius: 1%;
    background: $sc-checkbox-unchecked-color;
    color: $sc-checkbox-unchecked-color;
    user-select: none;
  }

  input:disabled + label:before {
    background-color: $sc-disabled-input-bg;
    color: $sc-disabled-input-bg;
    opacity: $sc-disabled-input-opacity;
    cursor: auto;
   }

  input:checked + label:before {
    @extend label:before;
    background: $sc-checkbox-checked-color;
  }

  input[type=checkbox] {
    display: none;
  }

  input:disabled + label {
    opacity: $sc-disabled-input-opacity;
    cursor: auto;
  }
</style>
